
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zgody",
      function () {
        return require("private-next-pages/zgody.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zgody"])
      });
    }
  